import { FC } from 'react';
import { NotificationsAssignments } from './NotificationsAssignments';
import { NotificationsAssignmentsMeetings } from './NotificationsAssignmentsMeetings';
import { typeMeeting, typeUser } from '@monorepo/models';

type propsType = {
    meetings: typeMeeting[];
    onlyToOverseerAndAssistance: boolean;
    users: typeUser[];
};

export const NotificationsMeetingCleaning: FC<propsType> = ({ meetings, onlyToOverseerAndAssistance, users }) => {

    return (
        <NotificationsAssignments
            content={!!meetings.length ?
                meetings.map(m =>
                    <NotificationsAssignmentsMeetings key={m.id}
                        content={m.groupsForCleaning.filter(g => g).map(g =>
                            <div key={`${m.id}_${g}`}>
                                <h5 key={`${m.id}_${g}`} className={'mt-2'}>
                                    Grupo {g}
                                </h5>
                                {users.filter(u => u.group === g && (!onlyToOverseerAndAssistance || u.groupIsTheOverseer || u.groupIsTheAssistance)).map(u =>
                                    <li key={`${m.id}_${u.id}`} className={'mt-2'}>
                                        <span className={'fw-bold'}>
                                            {u.name} {u.lastName} | {u.phoneNumber ? <span className={'bg-success'}>Teléfono: {u.phoneNumber}</span> : <span className={'bg-general-red'}>Sin teléfono cargado - No recibirá notificaciones</span>}
                                        </span>
                                    </li>
                                )}
                            </div>
                        )}
                        meeting={m}
                    />
                )
                :
                <>No hay ninguna asignación</>
            }
        />
    );
}
